import React from "react";
import { Box, Typography, useTheme } from "@mui/material";
import PropTypes from "prop-types";

interface Props {
  doneComments: number;
  physicalComments: number;
}

export const TableRowScannedComments: React.FC<Props> = ({
  doneComments,
  physicalComments,
}) => {
  const theme = useTheme();

  if (!physicalComments || physicalComments === 0) {
    return (
      <Typography
        variant="body2"
        sx={{
          color: "text.disabled",
          fontSize: "0.85rem",
          fontWeight: 500,
          userSelect: "none",
        }}
      >
        —
      </Typography>
    );
  }

  const percentage = Math.min(
    100,
    Math.round((doneComments / physicalComments) * 100)
  );
  const isComplete = percentage === 100;
  const barColor = isComplete ? "#10B981" : "#D97706";

  return (
    <Box
      sx={{
        width: "100%",
        maxWidth: 130,
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
      }}
    >
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          mb: 0.5,
        }}
      >
        <Typography
          variant="body2"
          sx={{
            fontSize: "0.78rem",
            fontWeight: 600,
            color: isComplete ? "success.main" : "text.primary",
          }}
        >
          {`${doneComments}/${physicalComments}`}
        </Typography>
        <Typography
          variant="caption"
          sx={{
            fontSize: "0.7rem",
            fontWeight: 500,
            color: "text.secondary",
          }}
        >
          {percentage}%
        </Typography>
      </Box>

      <Box
        sx={{
          backgroundColor:
            theme.palette.mode === "dark"
              ? "rgba(255, 255, 255, 0.08)"
              : "rgba(0, 0, 0, 0.06)",
          height: 5,
          width: "100%",
          borderRadius: 3,
          overflow: "hidden",
        }}
      >
        <Box
          sx={{
            height: "100%",
            width: `${percentage}%`,
            borderRadius: 3,
            backgroundColor: barColor,
            transition: "width 0.4s cubic-bezier(0.4, 0, 0.2, 1)",
          }}
        />
      </Box>
    </Box>
  );
};

TableRowScannedComments.propTypes = {
  doneComments: PropTypes.number.isRequired,
  physicalComments: PropTypes.number.isRequired,
};